module.exports = __webpack_public_path__ + "static/media/lee.52611844.jpg";